/**
 * POS HOOKS
 */

import React from 'react'

export const usePOS = () => {
    const [authorized, setAuthorized] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string | null>(null);

    const fetchAuthorization = React.useCallback(async (pinCode?: string, terminal?: string) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/users/pos/access`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ pinCode, terminal }),
            })

            const data = await response.json()

            if (data.success) {
                setAuthorized(true);
                return data.data
            } else {
                throw new Error(data.message)
            }
        } catch (error) {
            setAuthorized(false);
            setError(error instanceof Error ? error.message : 'Unknown error');
        }
    }, [])

    return {
        authorized,
        fetchAuthorization,
        error,
    }
}

export default usePOS